<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { notify } from '@/helpers/notify' 
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
    page: {
        title: "Uzatmayanlar Listesi",
    },
    mixins: [ datatableMixin ],
    components: {
        Layout,
        PageHeader,
        Datatable
    },
    computed: {
       ...mapGetters('authfack',['userdata'])
    },
    data() {
     return {
            title: "UZATMAYANLAR LİSTESİ",
            items: [
                { text: "ANASAYFA", href: "/" },
                { text: "UZATMAYANLAR LİSTESİ", active: true }
            ],

            buttons:[
                { title:"Söküm Listesine At", icon:'bx bx-check', func:this.sokum},
                { title:"Ödeme Al", icon:'bx bx-credit-card', func:this.cikart},
            ],  

            searchParams: { status:6},
            columns: [
                { name: '', key: 'action', orderable: false },
                { name: 'Kullanıcı Adı', key: 'username'},
                { name: 'İsim Soyisim', key: 'fullname', width: 150 },
                { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', orderable: true, width: 150  },
                { name: 'Cep Telefonu', key: 'phonenumber', className: 'text-end', width: 150  },
                { name: 'Whatsapp', key: 'phonenumber2', className: 'text-end', width: 150  },
                { name: 'İl', key: 'province', className: 'text-end', width: 150},
                { name: 'Bölge', key: 'township', className: 'text-end',  width: 150  },
                { name: 'Adres', key: 'address', className: 'text-end',  width: 150  }
            ],
            tableData: {
            detail: false,
            excel: true,
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            endpoint: '/listeler/uzatmayanlar',
            exportName: 'UZATMAYANLAR_LISTESI',
        };
    },
   

    methods: {

        async loadPage() {
          
          this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
          
          const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
          if (this.params.page === 1) {
              this.tableData.data = response.data.data;
          } else {
              this.tableData.data = [...this.tableData.data, ...response.data.data];
          }
        
            this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
            this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
        },

        popoverContent(histories) {
            const listItems = histories.map(history => {
                return `
                <li>${history.description}</li>
                `;
            }).join('');

            return `<ul>${listItems}</ul>`;
        },

        
        expiredate(expiredate){
            return this.formatDate(expiredate, "DD.MM.YYYY HH:mm")
        },

     
        cikart(props){
            location.href='/musteri-ara?username=' + props.username
            /*
            this.$http.post('/listeler/uzatmayanlar/event', { cikart : props.id })
                .then(() => {
                    notify.success('Başarılı')
                    this.loadItems()
                })
                .catch(error => error)
                */
        },

        sokum(props){
            this.$http.post('/listeler/uzatmayanlar/event', { sok : props.id })
                .then(() => {
                    notify.success('Başarılı')
                    this.loadPage()
                })
                .catch(error => error)
        },

       
      
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />

    <div class="row"> 
      <div class="col-12">
        <Datatable 
              :columns="columns" 
              :tableData="tableData" 
              @sort-column="handleSortColumn"
              @search-query="reLoadPage"
              @excel-export="excelExport"
              :loading="isLoading"
              :poading="pageLoading">
          
             
          <!--<template #filter-province="{ row }">
                <select class="form-select form-select-sm" @change="loadPage()" v-model="searchParams.il">
                  <option value="">İl</option>
                  <option value="" v-for="(bolge,i) in ilList" :key="`il${i}`">1</option>
                </select>
          </template>-->

        
          <template #created_at="{ row }">
              {{ created_at(row) }}
          </template>
          
          <template #appointment="{ row }">
          
           <div v-if="row.postpone">
              <span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span>
              <span v-if="row.hasOwnProperty('histories') && row.histories.length > 0"  v-b-popover.hover.auto.right="popoverContent(row.histories)">
                {{ row.histories[0].description }}
              </span>
            </div>
            <div v-else>
              {{ formatDate(row.appointment_at, 'DD.MM.YYYY HH') + ':00' }}
            </div>
          </template>

          <template #address="{ row }">
            <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
          </template>

          <template #expiredate="{ row }">
              {{ expiredate(row.expiredate) }}
          </template>

          <template #phonenumber="{ row }">
              <a :href="`tel:${row.phonenumber}`"  >{{row.phonenumber}}</a>
          </template>
          <template #phonenumber2="{ row }">
                <a target="_blank" :href='`https://wa.me/${row.phonenumber2}`' >{{ row.phonenumber2}}</a>
          </template>
          
          <template #action="{ row }">
              <b-dropdown
                  toggle-class="font-size-16 p-0"
                  toggle-tag="a"
                  variant="white"
                  append-to-body
                  >
                  <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template> 
                    <b-dropdown-item 
                    v-for="(button,i) in buttons"
                    :key="i" 
                    @click="button.func(row)">
                      {{ button.title }}
                  </b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>